/**
 * 应用入口文件
 * 负责初始化 Vue 应用、配置插件和挂载应用
 */

import { createApp } from 'vue'
import pinia from './stores'

// Element Plus 相关导入
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 应用组件和路由
import App from './App.vue'
import router, { setupRouteGuard } from './router'
import '@/style/index.scss'

/**
 * 创建 Vue 应用实例
 */
const app = createApp(App)

/**
 * 注册 Element Plus 图标组件
 */
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

/**
 * 安装插件
 */
app.use(pinia)           // 安装 Pinia 状态管理
app.use(router)          // 安装 Vue Router
app.use(ElementPlus, {   // 安装 Element Plus
  locale: zhCn
})

/**
 * 设置路由守卫
 * 用于动态加载路由和处理导航拦截
 */
setupRouteGuard()

/**
 * 挂载应用到 DOM
 */
app.mount('#app')